// Import all actions
import * as actions from "../actions/snackbarActions";

export const initialState = {
  snackbarOpen: false,
  snackbarType: "success",
  snackbarMessage: "",
  snackbarNavPath: "",
  snackbarNavParams: {},
  snackbarAutoHideDuration: 10000,
};

export default function snackbarReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SNACKBAR:
      const {
        snackbarOpen,
        snackbarMessage,
        snackbarType,
        snackbarNavPath,
        snackbarNavParams,
        snackbarAutoHideDuration,
      } = action;
      return {
        ...state,
        snackbarOpen,
        snackbarType,
        snackbarMessage,
        snackbarNavPath,
        snackbarNavParams,
        snackbarAutoHideDuration,
      };
    default:
      return state;
  }
}
